import { ENV } from "@/core/config/env";
import routeTenant from "@/core/services/routeTenant.service"

const baseUrlTenant = routeTenant.routeBaseConfig();

const authority = [
    {
        path: baseUrlTenant,
        name: "authority",
        component: () => import("@/view/layout/Layout"),
        children: [
            {
                path: "authority",
                name: "authority",
                component: () => import("@/view/pages/authority/List")

            }
        ]
    },
]

export default authority
